var collapsible_list_component_rtlignore_default = {
  "ltr": "GqaUq",
  "rtl": "hj1TU",
  "iconContainer": "_-4VEs",
  "icon": "Ge2h5",
  "isExpanded": "RsVyE",
  "listDimensions": "bjlfX"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
